import React from "react";
import { Breadcrumbs as BreadcrumbsType } from "../../../templates/Page/PageTypes";
import { Link } from "../../elements/Link/Link";
import * as styles from "./Breadcrumbs.module.css";

interface Props {
  breadcrumbs?: BreadcrumbsType;
  style?: "white" | "gray";
}

export const Breadcrumbs: React.FC<Props> = ({
  breadcrumbs,
  style = "gray",
  ...props
}) => {
  if (!breadcrumbs) return null;
  const navClass = [styles.breadcrumbs];
  if (style === "white") {
    navClass.push(styles.white);
  }

  return (
    <nav className={navClass.join(" ")} aria-label="breadcrumbs">
      <ol>
        {breadcrumbs.map((crumb, idx) => {
          if (idx === breadcrumbs.length - 1) {
            return (
              <li key={`keyName-${idx}`} aria-current="location">
                {crumb.title}
              </li>
            );
          }
          return (
            <li key={`keyName-${idx}`} className={styles.separator}>
              <Link to={crumb.url} target="_self">
                {crumb.title}
              </Link>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
